/* Component Dependencies */
var originalBookingDetailsTemplate = require('templates/originalBookingDetails.hbs');
var originalBookingDetailsUpcomingResTemplate = require('templates/originalBookingDetails-upcomingRes.hbs');
var originalBookingDetailsassociateTemplate = require('templates/originalBookingDetails-associate.hbs');
var originalBookingDetailschangeConfirmationTemplate = require('templates/originalBookingDetails-changeConfirmation.hbs');
var Popup = require('libs/popup');
var AriesComponent = require('libs/aries-component');
var PageTakeover = require('libs/pageTakeover');
var ResponsiveWidgetHandler = require('reservation_libs/responsive-widget-handler');

ResponsiveWidgetHandler.create({
  type: 'originalBookingDetails',
  template: {
    'originalBookingDetails': originalBookingDetailsTemplate,
    'originalBookingDetails-upcomingRes': originalBookingDetailsUpcomingResTemplate,
    'originalBookingDetails-associate': originalBookingDetailsassociateTemplate,
    'originalBookingDetails-changeConfirmation':originalBookingDetailschangeConfirmationTemplate
  },
  subscribe: {
    'EDIT_PREF_CLOSE': 'refresh',
    'REFRESH_YOUR_REQUEST': 'refresh',
    'REFRESH_ORG_BOOKING_DETAILS': 'refresh'
  },
  bindEvents:function($){
    var _self = this;
    this.registerRoomPopups();
    this.initResponsiveUtils();

    _self.$el.find('.js-cancel-wrapper').on('click','.js-room-cancel',function(event){
       event.preventDefault();
      _self.openCancelRoomOverlay($(this));
    });

    _self.$el.find('.js-modify-button').on('click', function(event) {
      event.preventDefault();
      _self.pubsub.publish('OPEN_GUEST_INFO',[$(this).data('confirmation-number')]);
    });
    
    _self.$el.find('.js-room-summary').keypress(function (event) {
      if (event.keyCode == '13') {
          $(event.target).trigger('click');
      }
    });
    
    _self.$el.find('.js-toggle-item').on('click', function(event) {	
      event.preventDefault();	
      if(!$(this).hasClass('is-disabled')) {	
        _self.toggleItemHandler(event);	
      }	
    });
    window.$(this.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
    
    if (this.$el.data('showPopup')) {
      var selectedRoomIndex = this.$el.data('selectedRoomIndex');
      var cancelRoomPopup = new Popup({
        url: this.$el.find('.js-room-cancel').eq(selectedRoomIndex).attr('href'),
        open: true, 
        alternateCloseMarkup: true,
        sourceBlock: '.modal-content',
      });
      cancelRoomPopup.register();
    }
  },
  events: {	
    'click .js-accordian-container .t-icon-arrow-right' : 'initiateTakeover',
    'click .js-accordian-container .t-icon-navigation-close' : 'closeTakeover'
  },

  closeTakeover: function _closeTakeover(event){
    var $currentTarget = $(event.currentTarget);
    $currentTarget.find('.js-icon-mobile').removeClass('t-color-standard-10 t-icon-navigation-close').addClass('t-icon-arrow-right');
    this.summaryTakeover.hide();
  },  

  initiateTakeover: function _initiateTakeover(event){
    var $currentTarget = $(event.currentTarget),
      $container = $currentTarget.closest('.js-accordian-container'),
      _self = this;
    _self.summaryTakeover = PageTakeover.create({
      $el: $container,
      hidePageHeader: true,
      isNotRetainDisplayAttribute: true,
      beforeShow: function() {
        $container.find('.js-icon-mobile').addClass('t-color-standard-10');
        $container.find('.js-icon-mobile').removeClass('t-icon-arrow-right').addClass('t-icon-navigation-close');
        $container.find('.js-toggle-summary-section').removeClass('l-display-none');
      },
      afterHide: function () {
        $container.find('.js-toggle-summary-section').addClass('l-display-none');
        $container.find('.js-icon-mobile').removeClass('t-icon-navigation-close t-color-standard-10').addClass('t-icon-arrow-right');
      }
    });
    _self.summaryTakeover.init();
  },

  /**
    * This function is used to register the pop-up of CancelRoom 
  */
   openCancelRoomOverlay: function _openCancelRoomOverlay($element) {
    var cancelPopup = new Popup({
      open: true,
      url: $element.attr('href') || $element.data('url'),
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true
    });
    cancelPopup.register();
  },

  /**
   * This function calls popup register funtion as per the selector.
  */
  registerRoomPopups: function _registerRoomPopups(){
    // This function register popup on the click of roomdetails link in the upcoming reservations rooms list.
    this.registerPopup('.js-photo-gallery');
    // This function register popup on the click of roomdetails link in the upcoming reservations rooms list.
    this.registerPopup('.js-room-details-popover');    

    this.registerPopup('.js-cancellation-policy'); // cancellation policy link for m.com 
    // This function register popup on the click of rate details link in the upcoming reservations rooms list.
    this.registerRateDetailsPopup('.js-rate-details-link');

    this.registerPopup('.rate-details-link');
    this.registerPopup('.js-reservation-history-overlay');
    this.registerPopup('.js-tax-and-fee-details');

    // This function register popup on the click of cancellation policy link in the upcoming reservation rooms list for empower.
    this.registerCancellationPopup('.js-cancellation-policy-link');

    // This function register popup on the click of group facts link in the upcoming reservations rooms list.
    this.registerPopup('.js-group-facts-overlay');
  },
  /**
   * This function registers the popups overlay on multiple selectors in the tile.
   * @param selector gives the class of selected element to register popup.
  */
  registerPopup: function _registerPopup(selector) {
    var $element = this.$el.find(selector);
    if (this.$el.find(selector).length) {
      var popup = new Popup({
          url: $element.data('url'),
          selector: selector,
          sourceBlock: '.modal-content',
          alternateCloseMarkup: true
      });
      popup.register();
    }
  },
  /**
   * This function registers the popups overlay for rate details link in the tile.
   * @param selector gives the class of selected element to register popup.
  */
   registerRateDetailsPopup: function _registerRateDetailsPopup(selector) {
    var $element = this.$el.find(selector);
    
    if (this.$el.find(selector).length) {
      var popup = new Popup({
          selector: selector,
          sourceBlock: '.modal-content',
          alternateCloseMarkup: true
      });
      popup.register();
    }
  },
  /**
   * This function registers the popups overlay for cancellation policy link in the tile.
   * @param selector gives the class of selected element to register popup.
  */
   registerCancellationPopup: function _registerCancellationPopup(selector) {
    var $element = this.$el.find(selector);
    
    if (this.$el.find(selector).length) {
      var popup = new Popup({
          selector: selector,
          sourceBlock: '.modal-content',
          alternateCloseMarkup: true
      });
      popup.register();
    }
  },
  /**
   * This function is called when a response is recieved from server on initiating  an AJAX call through widget handler
   * @param  {jQuery DOM Object} $container: reference of container
   * @param  {Object} loader : reference of loading spinner to be removed.
   */
  onWidgetResponse: function($container, loader){
        // activates links after getting response
      this.subscribeDOMEvents();
      this.$activeContainer = $container;
      loader.removeLoader();
      window.$(this.$el).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
  }

});
